export default __webpack_public_path__ + "static/media/FakeWesternWithTwoMembranes.7e1de3ee.png";